export function formatDollars(value: number) {
    if (value === null) return '';
    return value.toFixed(2);
}
